export default __webpack_public_path__ + "static/media/data_recovery.b6785075.png";